export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-[#F0F9FF] to-white pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-black/0 to-black/0"></div>

      {/* Background Decorative Elements */}
      <div className="absolute right-0 top-1/4 w-96 h-96 bg-[#1A2332] rounded-full opacity-10 blur-3xl"></div>
      <div className="absolute right-20 top-1/3 w-64 h-64 bg-[#0EA5E9] rounded-full opacity-20 blur-2xl"></div>
      <div className="absolute right-40 top-1/2 w-48 h-48 bg-[#1A2332] rounded-full opacity-15 blur-xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">

            {/* ターゲットバッジ */}
            <div className="inline-flex items-center gap-2 bg-[#0EA5E9]/10 border border-[#0EA5E9]/30 text-[#0EA5E9] text-sm font-medium px-4 py-2 rounded-full">
              <i className="ri-user-smile-line text-base"></i>
              <span>サロン・治療院・職人業 個人事業主専門</span>
            </div>

            <h1 className="text-4xl lg:text-5xl font-extrabold text-[#1A2332] leading-tight">
              個人事業主のための<br />
              <span className="text-[#0EA5E9]">経理まるごと</span><br />
              丸投げサービス
            </h1>

            <p className="text-base text-gray-600 leading-relaxed max-w-xl">
              経理もパソコンも苦手でも大丈夫。<br />
              領収書を渡すだけで全部おまかせ。<br />
              月額 <strong className="text-[#1A2332]">8,800円（税込）</strong> から始める、記帳代行＆IT支援サービスです。
            </p>

            <div className="flex flex-wrap gap-4">
              <button onClick={scrollToContact} className="bg-[#1A2332] text-white px-8 py-4 rounded-lg hover:bg-[#0EA5E9] transition-all duration-300 flex items-center gap-2 cursor-pointer whitespace-nowrap">
                <span className="font-semibold">今すぐ無料相談する</span>
                <i className="ri-arrow-right-line"></i>
              </button>
              <button onClick={scrollToServices} className="bg-white text-[#1A2332] border-2 border-[#1A2332] px-8 py-4 rounded-lg hover:bg-[#1A2332] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap">
                <span className="font-semibold">サービスを見る</span>
              </button>
            </div>

            <div className="flex items-center gap-8 pt-4">
              <div>
                <p className="text-4xl font-bold text-[#0EA5E9]">¥8,800~</p>
                <p className="text-sm text-gray-600">月額料金（税込）</p>
              </div>
              <div className="h-12 w-px bg-gray-300"></div>
              <div>
                <p className="text-4xl font-bold text-[#0EA5E9]">丸投げ</p>
                <p className="text-sm text-gray-600">完全おまかせOK</p>
              </div>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/82387f85624e92e2066297bae99f4595.jpg"
                alt="サロン経営サポートサービス"
                className="w-full h-[700px] object-cover object-top rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
